export const USERPROFILE_ROOT = 'myprofile';
export const USERPROFILE_API_VERSION = '1.0';
